import React from 'react';
import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import type { KioskAlertSeverity, KioskAlertStatus } from './types';

const SEVERITY_COLOR: Record<KioskAlertSeverity, 'error' | 'warning' | 'info'> = { critical: 'error', warning: 'warning', info: 'info' };
const STATUS_COLOR: Record<KioskAlertStatus, 'error' | 'default' | 'success'> = { open: 'error', handled: 'default', cleared: 'success' };

export const SeverityChip = ({ severity }: { severity: KioskAlertSeverity }) => {
  const translate = useTranslate();
  return <Chip size="small" color={SEVERITY_COLOR[severity]} label={translate(`resources.kiosk-alerts.severities.${severity}`)} />;
};

export const AlertStateChip = ({ status }: { status: KioskAlertStatus }) => {
  const translate = useTranslate();
  return <Chip size="small" variant="outlined" color={STATUS_COLOR[status]} label={translate(`resources.kiosk-alerts.statuses.${status}`)} />;
};
